import axios from "axios";
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LoginActionType, LoginContext } from "../Components/Contexts/LoginContext";
import toast from "react-hot-toast";
import { getItemFromStorage } from "./utilsFuncs";

class TokenError extends Error {
  constructor(message) {
    super(message);
    this.name = "TokenError";
  }
}

export function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
}

function AxiosInterceptors() {
  const { dispatch } = useContext(LoginContext);

  const navigate = useNavigate();

  useEffect(() => {
    axios.interceptors.request.use(
      (request) => {
        request.headers.set(
          "authorization",
          "Bearer " + (getItemFromStorage("jwtToken") === null ? "" : getItemFromStorage("jwtToken"))
        );
        request.headers.set("X-XSRF-TOKEN", getCookie("XSRF-TOKEN"));
        return request;
      },
      (error) => {
        if (error.response && error.response.data) {
          return Promise.reject(error.response.data);
        }
        return Promise.reject(error.message);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        const authorization = response.headers.get
          ? response.headers.get("authorization")
          : response.headers.authorization;
        if (authorization) {
          const token = authorization.replace("Bearer ", "");
          dispatch({
            type: LoginActionType.RENEW_TOKEN,
            payload: token,
          });
        }
        return response;
      },
      (error) => {
        if (error.response.config.url.endsWith("/login")) {
          // handle login errors separately
          return error.response;
        } else {
          if (error.response?.status === 403 || error.response?.status === 401) {
            // in case the user is not authorized
            dispatch({
              type: LoginActionType.SET_LOGGED_OUT,
            });
            navigate("/");
            toast.error("Your session has ended", {
              id: "Your session has ended",
            });
            throw new TokenError("Your session has ended");
          } else {
            return Promise.reject(error);
          }
        }
      }
    );
  }, []);

  return <></>;
}

export default AxiosInterceptors;
